export const ADD_NEW_TRANSACTION_REQUEST = 'ADD_NEW_TRANSACTION_REQUEST'
export const ADD_NEW_TRANSACTION_SUCCESS = 'ADD_NEW_TRANSACTION_SUCCESS'
export const ADD_NEW_TRANSACTION_FAIL = 'ADD_NEW_TRANSACTION_FAIL'

export const GET_ALL_TRANSACTION_REQUEST = 'GET_ALL_TRANSACTION_REQUEST'
export const GET_ALL_TRANSACTION_SUCCESS = 'GET_ALL_TRANSACTION_SUCCESS'
export const GET_ALL_TRANSACTION_FAIL = 'GET_ALL_TRANSACTION_FAIL'